import React from 'react';

import { Link, useLocation } from 'react-router-dom';

import {

  articles,

  CATEGORY_LABELS,

  getArticlesByCategory,

} from '../../content/learn/registry';

import GuideTypeBadge from './GuideTypeBadge';



function LearnLayout({ title, description, children, breadcrumb, guideType, readMinutes }) {

  const location = useLocation();

  const scamArticles = getArticlesByCategory('scams');

  const guideArticles = getArticlesByCategory('guides');

  const digitalArticles = getArticlesByCategory('digital');



  const navLinkClass = (path) => {

    const active = location.pathname === path;

    return `block text-sm py-1 ${

      active ? 'text-blue-700 font-semibold' : 'text-gray-600 hover:text-gray-900'

    }`;

  };



  return (

    <div className="container mx-auto px-4 py-8">

      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-8">

        <aside className="lg:w-64 flex-shrink-0">

          <nav className="sticky top-8 p-4 bg-white rounded-lg shadow border border-gray-100 max-h-[calc(100vh-4rem)] overflow-y-auto">

            <Link to="/learn" className="font-semibold text-gray-900 hover:text-blue-700">

              Safety guides

            </Link>

            <p className="text-xs text-gray-500 mt-1 mb-4">{articles.length} articles</p>



            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mt-4 mb-2">

              {CATEGORY_LABELS.scams}

            </p>

            <ul className="space-y-1">

              {scamArticles.map((a) => (

                <li key={a.slug}>

                  <Link to={`/learn/${a.slug}`} className={navLinkClass(`/learn/${a.slug}`)}>

                    {a.title}

                  </Link>

                </li>

              ))}

            </ul>



            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mt-6 mb-2">

              {CATEGORY_LABELS.guides}

            </p>

            <ul className="space-y-1">

              {guideArticles.map((a) => (

                <li key={a.slug}>

                  <Link to={`/learn/${a.slug}`} className={navLinkClass(`/learn/${a.slug}`)}>

                    {a.title}

                  </Link>

                </li>

              ))}

            </ul>



            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mt-6 mb-2">

              {CATEGORY_LABELS.digital}

            </p>

            <ul className="space-y-1">

              {digitalArticles.map((a) => (

                <li key={a.slug}>

                  <Link to={`/learn/${a.slug}`} className={navLinkClass(`/learn/${a.slug}`)}>

                    {a.title}

                  </Link>

                </li>

              ))}

            </ul>



            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mt-6 mb-2">

              By country

            </p>

            <Link to="/learn/regions" className={navLinkClass('/learn/regions')}>

              Reporting resources

            </Link>

          </nav>

        </aside>



        <main className="flex-1 min-w-0">

          {breadcrumb && (

            <p className="text-sm text-gray-500 mb-4">{breadcrumb}</p>

          )}

          <header className="mb-8">

            {guideType && (

              <div className="mb-2">

                <GuideTypeBadge guideType={guideType} readMinutes={readMinutes} />

              </div>

            )}

            <h1 className="text-3xl font-bold text-gray-900">{title}</h1>

            {description && (

              <p className="text-lg text-gray-600 mt-2">{description}</p>

            )}

          </header>

          {children}

          <footer className="mt-12 pt-6 border-t border-gray-200 text-sm text-gray-500">

            <p>

              Educational content only — not legal or financial advice. Verify important

              information with official sources. Community reports on WhoDatNumber are

              moderated but provided as-is.

            </p>

            <Link to="/learn" className="inline-block mt-4 text-blue-600 hover:underline">

              ← All safety guides

            </Link>

          </footer>

        </main>

      </div>

    </div>

  );

}



export default LearnLayout;



